import React from "react";
import useSEO from "../hooks/useSEO";
import { motion } from "framer-motion";
import "./CookiePolicy.css";

const CookiePolicy = () => {
  useSEO({
    title: "La Psicologa Anna | Cookie Policy",
    description: "Informativa sui cookie del sito La Psicologa Anna.",
  });

  return (
    <motion.div
      className="page cookie-policy-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="cookie-policy">
        <h1>Cookie Policy</h1>

        <p>
          Questo sito utilizza cookie tecnici, necessari al suo corretto
          funzionamento, e, previo consenso dell'utente, cookie di analisi
          tramite Google Analytics. Non vengono utilizzati cookie di
          profilazione.
        </p>

        <h2>Che cosa sono i cookie?</h2>
        <p>
          I cookie sono piccoli file di testo che i siti web memorizzano sul
          dispositivo dell'utente durante la navigazione, per garantire alcune
          funzionalità e migliorare l'esperienza d'uso.
        </p>

        <h2>Tipologie di cookie utilizzati</h2>
        <ul>
          <li>
            <strong>Cookie tecnici:</strong> indispensabili per il funzionamento
            del sito, non richiedono il consenso dell'utente.
          </li>
          <li>
            <strong>Cookie di analisi:</strong> impiegati solo dopo il consenso
            per raccogliere statistiche anonime sull'utilizzo del sito tramite
            Google Analytics.
          </li>
        </ul>

        <h2>Strumenti di analisi (Google Analytics)</h2>

        <p>
          Utilizziamo <strong>Google Analytics</strong> per raccogliere
          informazioni anonime sulle visite al sito. Il servizio è attivato solo
          dopo il consenso espresso tramite il banner dei cookie e l'indirizzo
          IP viene anonimizzato. Per ulteriori dettagli consulta la{" "}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy di Google
          </a>
          .
        </p>
        <p>
          I cookie analitici sono disattivati per impostazione predefinita e
          vengono abilitati solo dopo il tuo consenso. Puoi revocarlo in
          qualsiasi momento cancellando i cookie dal tuo browser.
        </p>

        <h2>Google Fonts</h2>
        <p>
          Il sito utilizza <strong>Google Fonts</strong> per il caricamento dei
          caratteri. I font sono forniti da Google e possono comportare il
          trattamento dell'indirizzo IP dell'utente da parte di Google Inc. Per
          ulteriori informazioni si rimanda alla{" "}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Google Privacy Policy
          </a>
          .
        </p>

        <h2>Hosting su Vercel</h2>
        <p>
          Il sito è ospitato su <strong>Vercel Inc.</strong>, una piattaforma
          che può trattare dati tecnici come l'indirizzo IP e il tipo di
          dispositivo, al solo fine di garantire la sicurezza e la performance
          del servizio. Maggiori informazioni disponibili nella{" "}
          <a
            href="https://vercel.com/legal/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy di Vercel
          </a>
          .
        </p>

        <h2>Servizi esterni</h2>
        <p>
          Il sito incorpora un widget di <strong>MioDottore.it</strong> che
          consente la prenotazione di appuntamenti direttamente dalla pagina.
          L'integrazione avviene tramite uno script esterno fornito da
          Docplanner Group, che può utilizzare cookie o tecnologie simili per il
          funzionamento del servizio e per analisi statistiche. Per ulteriori
          dettagli, consulta la loro{" "}
          <a
            href="https://www.miodottore.it/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            privacy policy
          </a>
          .
        </p>
        <h2>Diritti dell'utente</h2>
        <p>
          L'utente ha il diritto di accedere, rettificare o cancellare i propri
          dati personali, laddove applicabile, secondo quanto previsto dal
          Regolamento UE 2016/679 (GDPR). Per maggiori informazioni consulta la{" "}
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          .
        </p>

        <p>
          <em>Ultimo aggiornamento: dicembre 2025</em>
        </p>
      </div>
    </motion.div>
  );
};

export default CookiePolicy;
